import { RemindersService } from '~modules/features/reminders';
export const RemindersRoutes = [
    {
        name: 'list',
        path: '/',
        component: () => import('./reminders').then(m => m.Reminders),
        onActivate: () => Promise.all([RemindersService.getAll([0, 0, 0], 20), RemindersService.getCount()])
    }
];
